import { Component, OnInit } from '@angular/core';
import { SectionBase } from '../../../components/section/section-base';
import { ContactDataConsts } from '../../../../core/consts/contact-data.consts';
import { AssetsService } from '../../../services/assets.service';
import { LanguageService } from '../../../services/language.service';
import { PredefinedValuesService } from '../../../../core/services/impl/section-services/predefined-values/predefined-values.service';
import { PredefinedValuesStateService } from '../../../../core/services/impl/section-services/predefined-values/predefined-values-state.service';
import { UrlParamsService } from '../../../../core/services/impl/url-params.service';
import { ContactDataSectionConfig } from './contact-data-section.config';
import { InsurerContactDataService } from '../../../../core/services/impl/section-services/insurer-contact-data/insurer-contact-data.service';
import {isNext} from '../../../../core/utils/utils';
import {RegExpService} from '../../../services/reg-exp.service';

@Component({
  selector: 'app-contact-insurer-data-section',
  templateUrl: './contact-insurer-data-section.component.html',
  styleUrls: ['./contact-insurer-data-section.component.scss']
})
export class ContactInsurerDataSectionComponent extends SectionBase implements OnInit {

  title = 'CONTACT_INSURER_DATA_SECTION.title';
  public config: ContactDataSectionConfig = new ContactDataSectionConfig(this.predefined, this.urlParamsService, this.regExpService);
  public consts = ContactDataConsts;
  isNext = isNext();
  private iconsDirectoryPath: string;

  constructor(public stateService: InsurerContactDataService,
              private assetsService: AssetsService,
              private languageService: LanguageService,
              private predefined: PredefinedValuesService,
              private predefinedState: PredefinedValuesStateService,
              private urlParamsService: UrlParamsService,
              private regExpService: RegExpService) {
    super();
    this.iconsDirectoryPath = this.assetsService.getIconsDirectoryPath();
  }

  ngOnInit() {
    this.initBean();
    this.initIsFieldDirtyBean();
    this.createConfig();
    this.buildForm();
    this.initControlsChanges();
  }

  initBean() {
    this.bean = this.stateService.contactDataBean;
  }

  createConfig() {
    this.formConfig = this.config.createConfig(this.languageService.getDefaultLanguage());
  }

  initControlsChanges() {
    this.handleControlsState(
        {controlName: this.consts.EMAIL, behaviour: value => this.stateService.changeEmail(value)},
      {controlName: this.consts.PHONE_NUMBER, behaviour: value => this.stateService.changePhoneNumber(value)}
      );
  }

  markAsDirty(event) {
    this.predefinedState.isDirtyBean = event;
  }

  private initIsFieldDirtyBean() {
    this.isDirtyBean = this.predefinedState.isDirtyBean;
  }

}
